import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseVoltageService } from '../../../../services/base-voltage.service';
import { CimSubstationService } from '../../../../services/cim-substation.service';
import { GeographicalRegionService } from '../../../../services/geographical-region.service';
import { SubGeographicalRegionService } from '../../../../services/sub-geographical-region.service';
import { SubstationTemplateService } from '../../../../services/substation-template.service';
import { UtilitySharedService } from '../../../../services/shared//utility-shared.service';
import { CimSubstationForSave, ParentSubstation } from '../../../../models/cim-substation.model';
import { AcLineCountForSubstation, SubstationTemplateForSelect } from '../../../../models/network-structure.model';
import { GeographicalRegion } from '../../../../models/geographical-region.model';
import { SubGeographicalRegion } from '../../../../models/sub-geographical-regions.model';
import { ObjectDropdownComponent } from '../../../common/object-dropdown/object-dropdown.component';
import { SelectSubstationDataIn } from '../../../../models/substation-template-instance.model';
import { AcLineSegmentService } from '../../../../services/ac-line-segment.service';
import { AssetRatingService } from '../../../../services/asset-rating.service';
import { AssetRating } from '../../../../models/asset-rating.model';
import { PermissionsService } from '../../../../services/permissions.service';

@Component({
  selector: 'lib-nec-substation-details',
  standalone: false,
  templateUrl: './nec-substation-details.component.html',
  styleUrls: ['./nec-substation-details.component.scss', '../nec-substation.component.scss', '../../network-entity-classes.component.scss']
})
export class NecSubstationDetailsComponent {
  @ViewChild('closeEditModal') closeEditModal!: ElementRef;
  @ViewChild('dropdownDistrict') dropdownDistrict!: ObjectDropdownComponent;
  @Input() data: any;
  @Input() autoOpenSchematic: boolean = false;
  @Output() closed = new EventEmitter<void>();
  @Output() saveOrDeleteSuccess = new EventEmitter<boolean>();
  @Output() autoOpenSchematicHandled = new EventEmitter<void>();

  tabs: any[] = 
  [
    {id: 1, name: 'Equipment & Connectivity'},
    {id: 2, name: 'Overview'}
  ];
  selectedTabId: number = 1;
  selectedTabName: string = '';

  hasEquipment: boolean | null = null;
  acLineCounts: AcLineCountForSubstation = new AcLineCountForSubstation();

  equipmentsConnectivites: any[] = 
  [
    {id: 1, name: 'Power Transformer'},
    {id: 2, name: 'Ac Line Segment'},
    {id: 3, name: 'Busbar', value: 'Busbar'},
    {id: 4, name: 'Junction', value: 'Junction'},
    {id: 5, name: 'Jumper', value: 'Jumper'},
    {id: 6, name: 'Fuse', value: 'Fuse'},
    {id: 7, name: 'Disconnector', value: 'Disconnector'},
    {id: 8, name: 'Ground Disconnector', value: 'GroundDisconnector'},
    {id: 9, name: 'Circuit Breaker', value: 'Breaker'},
    {id: 10, name: 'Load Break Switch', value: 'LoadBreakSwitch'},
  ]

  selectedEquipment: any = null;

  selectedEqConnId: number = 1;

  substationForSave: CimSubstationForSave = new CimSubstationForSave();
  
  substationTemplatesForSelect: SubstationTemplateForSelect[] = []
  substationTemplateValue: SubstationTemplateForSelect | null = null;

  utilityId!: number;

  geoRegions: GeographicalRegion[] = [];
  geographicalRegionValue: GeographicalRegion | null = null;
  updatedRegionId: number | null = null;

  subGeoRegions: SubGeographicalRegion[] = [];
  subGeographicalRegionValue: SubGeographicalRegion | null = null;

  baseVoltages: any[] = [];
  baseVoltageValue: any | null = null;

  suppliedRegionName: string = '';
  suppliedDistrictName: string = '';

  showParentSubstationDropdowns: boolean = true;
  addedAcLinesOutgoing: any[] = []

  parentSubstations: any[] = []; //for select
  updatedParentSubstationId: number | null = null; //using SubstationId, not SubstationTemplateInstanceId

  outgoingAcLineSegments: any[] = []
  updatedAcLineOutgoingId: number | null = null;
  updateAcLineOutgoingName: string | null = null;

  isSchematicOpen = false;
  ratingOptions: AssetRating[] = [];
  
  eqCount = 0;
  constructor
  (
    private toastr: ToastrService, 
    private substationTemplateService: SubstationTemplateService,
    private utilitySharedService: UtilitySharedService,
    private cimSubstationService: CimSubstationService,
    private assetRatingService: AssetRatingService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService,
    private baseVoltageService: BaseVoltageService,
    private acLineService: AcLineSegmentService,
    public permissionsService: PermissionsService
  ){}

   ngOnInit(): void {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
    this.getEquipmentStatus();
    this.getAcLineCountForSubstation();
    this.getAllSubstationTemplatesForSelect();
    this.getAllGeographicalRegionsForSelect();
    this.getAllBaseVoltagesForSelect();
    this.getAllParentSubstationsForSelect(new SelectSubstationDataIn(""));
    this.loadRatings();
    this.getEqCount();

    if (this.autoOpenSchematic) {
      // Auto-open is for placing a just-added instance on the schematic, so it needs Create/Edit.
      if (this.permissionsService.isSchematicDiagramCreateEditAllowed) this.openSchematic();
      this.autoOpenSchematicHandled.emit();
    }
  }

  loadRatings() {
    this.assetRatingService.getAllForSelect().subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          this.ratingOptions = response.data;
        } else {
          this.ratingOptions = [];
        }
      },
      error: (_) => {
        this.toastr.error('Failed to fetch ratings');
      },
    });
  }

  close() {
    this.closed.emit();
  }
  getEqCount(){
      this.substationTemplateService.getEquipmentCnt(this.data.id).subscribe({
      next: (response: any) => {
        if (response?.status === 'OK' || response?.status === 200) {
         this.eqCount = response.body.data
        } 
      },
      error: (_: any) => {
        this.toastr.error('An error occurred during download.');
      },
    })
  }
  savedOrDeletedSuccess(isSave: boolean) {
    this.saveOrDeleteSuccess.emit(isSave);
  }

  switchTab(tab: any){
    this.selectedTabId = tab.id;
    this.selectedTabName = tab.name;
  }

  switchEqConn(eqConn: any){
    this.selectedEqConnId = eqConn.id;
    this.selectedEquipment = this.equipmentsConnectivites.find(e => e.id === this.selectedEqConnId);
  }

  selectSubstation(){
    this.substationForSave = new CimSubstationForSave();
    this.substationForSave.id = this.data.id;
    this.substationForSave.substationTemplateId = this.data.substationTemplateId;
    this.substationForSave.name = this.data.name;
    this.substationForSave.number = this.data.number;
    this.substationForSave.baseVoltageId = this.data.baseVoltage?.id;
    this.substationForSave.subGeographicalRegionId = this.data.subGeographicalRegion?.id;

    if(this.data.baseVoltage)
      this.data.baseVoltage.name = this.data.baseVoltage.nominalVoltage + 'KV';
    this.baseVoltageValue = this.data.baseVoltage;
    this.geographicalRegionValue = this.data.subGeographicalRegion?.geographicalRegion;

    if(this.geographicalRegionValue)
      this.geographicalRegionValue!.name = this.geographicalRegionValue?.name.toUpperCase() ?? '';
    this.onSelectGeographicalRegion(this.data.subGeographicalRegion?.geographicalRegion, false);
    this.subGeographicalRegionValue = this.data.subGeographicalRegion;
    this.substationTemplateValue = new SubstationTemplateForSelect(this.data.substationTemplateId, this.data.substationTemplateName);

    this.showParentSubstationDropdowns = true;
    this.substationForSave.parentSubstations = []
    this.addedAcLinesOutgoing = []
    if(this.data.parentSubstations?.length !== 0)
      this.setParentSubstationData(this.data.parentSubstations);

    this.suppliedRegionName = this.data.subGeographicalRegion?.geographicalRegion.name;
    this.suppliedDistrictName = this.data.subGeographicalRegion?.name;
  }

  setParentSubstationData(parentSubstationsInit: any){
  
      if (!this.substationForSave.parentSubstations) {
        this.substationForSave.parentSubstations = [];
      }
  
      if (parentSubstationsInit && Array.isArray(parentSubstationsInit)) {
        parentSubstationsInit.forEach((ps: any) => {
          const mappedItem: ParentSubstation = {
            parentSubstationId: ps.parentSubstationId,       
            parentSubstationACLineId: ps.parentACLineId 
          };
  
          this.substationForSave.parentSubstations!.push(mappedItem);
        });
      }
  
      if (parentSubstationsInit && Array.isArray(parentSubstationsInit)) {
        parentSubstationsInit.forEach((ps: any) => {
          const mappedItem: any = {
            acLineId: ps.parentACLineId,
            acLineName: ps.parentACLineName,
            isExisting: true // existing incoming lines can only be removed on the schematic
          };
  
          this.addedAcLinesOutgoing.push(mappedItem);
        });
      }
  
      this.showParentSubstationDropdowns = false;
    }

  onRemove(){
    this.cimSubstationService.delete(this.data.id, this.data.substationTemplateId, this.data.name).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success(responseData?.message);
          this.savedOrDeletedSuccess(false);
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getAcLineCountForSubstation() {
    this.acLineService.getCountBySubstationId(this.data.substationId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK' || responseData?.status === 204) {
          this.acLineCounts = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading ac line count');
      },
    });
  }

  getAllSubstationTemplatesForSelect() {
    this.substationTemplateService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.substationTemplatesForSelect = responseData.data.map((substationTemplate: SubstationTemplateForSelect) => ({
            ...substationTemplate
          }));
        } else if (response?.status === 204) {
          this.substationTemplatesForSelect = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading substation templates');
      },
    });
  }

  onSelectSubstationTemplate(obj: SubstationTemplateForSelect | null) {
    if (obj)
      this.substationForSave.substationTemplateId = obj.id ?? 0;
  }

  getAllGeographicalRegionsForSelect() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geoRegions = responseData.data.map((geoRegion: GeographicalRegion) => ({
            ...geoRegion,
            name: geoRegion.name?.toUpperCase(),
            isExpanded: false,
          }));
        } else if (response?.status === 204) {
          this.geoRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading regions');
      },
    });
  }
  
  onSelectGeographicalRegion(obj: GeographicalRegion | null, isNotEditInit: boolean = true) {
    if (obj){
      this.updatedRegionId = obj.id;
      this.suppliedRegionName = obj.name;
      this.suppliedDistrictName = '';
      if(isNotEditInit){
        this.dropdownDistrict.selectItem(null);
        this.substationForSave.subGeographicalRegionId = null;
      }
      this.getAllSubGeographicalRegionsForSelect(obj.id ?? 0);
    }
  }

  getAllSubGeographicalRegionsForSelect(regionId: number){
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.subGeoRegions = responseData.data
          .filter((subGeoRegions: SubGeographicalRegion) => subGeoRegions.geographicalRegion.id === regionId)  
          .map((subGeoRegions: SubGeographicalRegion) => ({
            ...subGeoRegions,
            isExpanded: false,
          }));
        } else if (response?.status === 204) {
          this.subGeoRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading districts');
      },
    });
  }

  onSelectSubGeographicalRegion(obj: SubGeographicalRegion | null) {
    if (obj){
      this.suppliedDistrictName = obj.name;
      this.substationForSave.subGeographicalRegionId = obj.id!;
    }
  }

    getAllBaseVoltagesForSelect() {
    this.baseVoltageService.getAllForMappings(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.baseVoltages = responseData.data.map((baseVoltage: any) => ({
            ...baseVoltage,
            name: `${baseVoltage.name}KV`
          }));
        } else if (response?.status === 204) {
          this.baseVoltages = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading base voltages');
      },
    });
  }

  onSelectBaseVoltage(obj: any | null) {
    if (obj)
      this.substationForSave.baseVoltageId = obj.id ?? 0;
  }

  save(){
    if (this.substationForSave.substationTemplateId === null) {
      this.toastr.warning("Please select an instance category!")
    } else if(this.substationForSave.name === ''){
      this.toastr.warning("Asset Name can't be empty!")
    } else if (this.substationForSave.number === '') {
      this.toastr.warning("Asset Number can't be empty!")
    } else if (this.substationForSave.baseVoltageId === null) {
      this.toastr.warning("Please select a base voltage category!")
    } else if (this.substationForSave.subGeographicalRegionId === null) {
      this.toastr.warning("Please select a district category!")
    } else {
       this.cimSubstationService.save(this.substationForSave).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('Substation updated successfully');
          this.closeEditModal?.nativeElement?.click();
          this.savedOrDeletedSuccess(true);
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
    }
  }

  getAllParentSubstationsForSelect(dataIn: SelectSubstationDataIn){
    this.cimSubstationService.getForSelect(dataIn).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.parentSubstations = responseData.data.map((parentSubstation: any) => ({
            ...parentSubstation
          }));
        } else if (response?.status === 204) {
          this.parentSubstations = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading parent substations');
      },
    });
  }

  onSelectParentSubstation(obj: any | null){
      if (obj){
        this.updatedParentSubstationId = obj.id;
        this.getAllOutgoingLines(obj.id ?? 0);
      }
    }
  
    getAllOutgoingLines(substationId: number){
        this.cimSubstationService.getOutgoingLines(substationId).subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.outgoingAcLineSegments = responseData.data.map((outgoingAcLineSegment: any) => ({
              ...outgoingAcLineSegment
            }));
          } else if (response?.status === 204) {
            this.outgoingAcLineSegments = [];
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occurred while loading outgoing ac line segments');
        },
      });
    }
  
    onSelectAcLineOutoging(obj: any | null){
      if (obj){
        this.updatedAcLineOutgoingId = obj.id;
        this.updateAcLineOutgoingName = obj.name;
        this.addParentSubstationAndAcLineOutoging();
      }
    }
  
    addParentSubstationAndAcLineOutoging(){
      if(this.substationForSave.parentSubstations?.some(p => p.parentSubstationACLineId === this.updatedAcLineOutgoingId)){
        this.toastr.warning("You already added this Ac Line.")
        this.showParentSubstationDropdowns = false;
        return;
      };
  
      this.createAcLineLabelForModal();
  
      const newItem: ParentSubstation = {
        parentSubstationId: this.updatedParentSubstationId,
        parentSubstationACLineId: this.updatedAcLineOutgoingId
      };
  
      if (!this.substationForSave.parentSubstations) {
        this.substationForSave.parentSubstations = [newItem]; 
      } else {
        this.substationForSave.parentSubstations.push(newItem); 
      }
  
      this.showParentSubstationDropdowns = false;
  
      this.updatedParentSubstationId = null;
      this.updatedAcLineOutgoingId = null;
    }
  
    createAcLineLabelForModal(){
      const newItem: any = {
        acLineId: this.updatedAcLineOutgoingId,
        acLineName: this.updateAcLineOutgoingName
      };
  
      if (!this.addedAcLinesOutgoing) {
        this.addedAcLinesOutgoing = [newItem]; 
      } else {
        this.addedAcLinesOutgoing.push(newItem); 
      }
    }
  
    removeFromLists(acLineId: number){
      if(!this.substationForSave.parentSubstations) return;
  
      this.addedAcLinesOutgoing = this.addedAcLinesOutgoing.filter(p => p.acLineId !== acLineId);
      this.substationForSave.parentSubstations = this.substationForSave.parentSubstations!.filter(p => p.parentSubstationACLineId !== acLineId);
  
      if(!this.substationForSave.parentSubstations || this.substationForSave.parentSubstations.length === 0)
        this.showParentSubstationDropdowns = true;
    }
  
    onSearchTextChange(inputText: string){
      if (this.parentSubstations.length !== 0) {
        this.getAllParentSubstationsForSelect(new SelectSubstationDataIn(inputText));
      }
    }
  
    addParentSubstation() {
      this.showParentSubstationDropdowns = true;
    }

    onBackdropClick(event: MouseEvent) {
      // If click is *directly* on the backdrop → close
      if (event.target === event.currentTarget) {
        this.close();
      }
    }

    getEquipmentStatus() {
      this.cimSubstationService.getEquipmentStatus(this.data.substationId).subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.hasEquipment = responseData.data;
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occurred while loading substation templates');
        },
    });
  }

  openSchematic() {
    this.isSchematicOpen = true;
  }

  closeSchematic() {
    this.isSchematicOpen = false;
  }
}
